import { graphql, StaticQuery } from 'gatsby'
import * as _ from 'lodash'
import * as React from 'react'
import Helmet from 'react-helmet'

import { resolvePageUrl } from '../../utils/utils'

export const SetHead = ({
  path,
  title: propTitle,
  description: propDescription,
  imageName,
}: {
  path: string
  title?: string
  description?: string
  imageName: string
}) => {
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              author
              siteUrl
              fbAppID
              twitterAppID
            }
          }
          images: allFile {
            edges {
              node {
                publicURL
                relativePath
              }
            }
          }
        }
      `}
      render={data => {
        const {
          siteUrl,
          title: metaTitle,
          description: metaDescription,
          author,
          fbAppID,
          twitterAppID,
        } = data.site.siteMetadata
        const pageUrl = resolvePageUrl(siteUrl, path)

        const imageResult = data.images.edges.find(n => {
          return n.node.relativePath.includes(imageName)
        })

        const publicURL = _.get(imageResult, 'node.publicURL')

        const title = propTitle ? propTitle : metaTitle
        const description = propDescription ? propDescription : metaDescription

        // console.log(window.dataLayer)
        // window.dataLayer.push({ event: 'boyeah' })
        return (
          <Helmet
            title={data.site.siteMetadata.title}
            titleTemplate={`%s ${propTitle ? `| ${propTitle}` : ''}`}
          >
            <html lang="en" />
            <meta name="description" content={description} />
            <meta name="image" content={publicURL} />
            <link rel="canonical" href={pageUrl} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={title} />

            <meta property="og:url" content={pageUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={`${siteUrl}${publicURL}`} />
            <meta property="fb:app_id" content={fbAppID} />

            <meta name="twitter:card" content="photo" />
            <meta name="twitter:site" content={author} />
            <meta name="twitter:creator" content={'@drstephenjensen'} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={publicURL} />
            <meta name="twitter:url" content={pageUrl} />
            <script
              id="stripe-js"
              src="https://js.stripe.com/v3/"
              async
            ></script>
          </Helmet>
        )
      }}
    />
  )
}
